import { render, staticRenderFns } from "./TeamOne.vue?vue&type=template&id=dfae045a&"
import script from "./TeamOne.vue?vue&type=script&lang=js&"
export * from "./TeamOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports